import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart3 } from "lucide-react";

export const StatsAdmin = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    }, []);

    if (!stats) return <p className="text-sm text-[#9C917D]">Lade Statistik …</p>;
    const max = Math.max(1, ...stats.days.map((d) => d.count));

    return (
        <div data-testid="admin-stats">
            <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
                <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Besuche (30 Tage)</p>
                    <p className="mt-2 font-display text-4xl font-black text-[#C88A45]" data-testid="stats-total">{stats.total}</p>
                </div>
                <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Heute</p>
                    <p className="mt-2 font-display text-4xl font-black text-[#EDE6DA]" data-testid="stats-today">{stats.days[stats.days.length - 1]?.count ?? 0}</p>
                </div>
                <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Top-Quelle</p>
                    <p className="mt-2 truncate font-display text-2xl font-black text-[#EDE6DA]" data-testid="stats-topsource">{stats.sources[0]?.source || "—"}</p>
                </div>
            </div>

            <div className="mb-8 rounded border border-[#2E2517] bg-[#1B150E] p-6" data-testid="stats-chart">
                <p className="mb-4 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">
                    <BarChart3 size={14} className="text-[#C88A45]" /> Besuche pro Tag (letzte 30 Tage)
                </p>
                <div className="flex h-32 items-end gap-1">
                    {stats.days.map((d) => (
                        <div
                            key={d.date}
                            title={`${new Date(d.date + "T12:00:00").toLocaleDateString("de-DE")}: ${d.count}`}
                            className="flex-1 rounded-t bg-[#C88A45]/70 transition-all duration-300 hover:bg-[#C88A45]"
                            style={{ height: `${Math.max(3, (d.count / max) * 100)}%` }}
                        />
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6" data-testid="stats-sources">
                    <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Woher kommen Besucher</p>
                    {stats.sources.length === 0 && <p className="text-sm text-[#9C917D]">Noch keine Daten.</p>}
                    <div className="space-y-2">
                        {stats.sources.map((s) => (
                            <div key={s.source} className="flex justify-between text-sm">
                                <span className="text-[#EDE6DA]">{s.source}</span>
                                <span className="text-[#C88A45]">{s.count}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6" data-testid="stats-paths">
                    <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Beliebte Seiten</p>
                    {stats.paths.length === 0 && <p className="text-sm text-[#9C917D]">Noch keine Daten.</p>}
                    <div className="space-y-2">
                        {stats.paths.map((p) => (
                            <div key={p.path} className="flex justify-between text-sm">
                                <span className="text-[#EDE6DA]">{p.path === "/" ? "Startseite" : p.path}</span>
                                <span className="text-[#C88A45]">{p.count}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <p className="mt-6 text-xs text-[#9C917D]">Anonymisierte Statistik ohne Cookies — es werden nur Seitenaufrufe und die Herkunftsseite gezählt, keine personenbezogenen Daten.</p>
        </div>
    );
};
